<template>
    <div class="living-options-properties">
      <div class="row">
        <div class="col-12">
          <div class="properties">
            <h5>Properties</h5>
            <button class="btn btn-primary mb-4" @click="addProperty()">Add Property</button>
            <div class="mb-2">
              <input class="form-control" type="text" v-model="propertiesFilterText" placeholder="Filter properties">
            </div>
            <v-table
              :columns="[
                { label: 'Label', field: 'label'},
                { label: 'Status', field: 'status'},
                { label: 'Price', field: 'price'},
              ]"
              :rows="filteredProperties"
              :show-active-toggle="activeUser.access.indexOf('live-toggle') !== -1"
              save-action="SAVE_PROPERTY"
              @edit="activePropertyId = $event._id"
              @clone="cloneProperty($event)"
              @delete="deleteProperty($event._id)"
            />
          </div>
        </div>
      </div>
      <modal-popup :isVisible="!!activeProperty" @closeModal="closeModal">
        <div v-if="activeProperty" class="modal-row-padding">
          <div class="col-12 mb-4">
            <div class="row">
              <div class="col-12">
                <h3>Editing {{ activeProperty.label }}</h3>
              </div>
            </div>
          </div>
          <div class="col-6 mb-4">
            <div class="row">
              <div class="col-6 mb-4">
                Label
                <input
                  type="text"
                  class="form-control form-control-lg"
                  v-model="activeProperty.label"
                  placeholder="i.e. apartment"
                />
              </div>
              <div class="col-6 mb-4">
                Status
                <select class="form-control" v-model="activeProperty.status">
                  <option value="Available">Available</option>
                  <option value="Builder Lots">Builder Lots</option>
                  <option value="On Hold">On Hold</option>
                  <option value="Sold">Sold</option>
                  <option value="Not Released">Not Released</option>
                  <option value="Unassigned">Unassigned</option>
                </select>
              </div>
              <div class="col-6 mb-4">
                Price
                <input
                  type="text"
                  class="form-control"
                  :value="activeProperty.price"
                  @input="event => activeProperty.price = event.target.value.replace(/[^0-9.]/g, '')"
                />
              </div>
              <div class="col-6 mb-4">
                Frontage
                <input
                  type="number"
                  class="form-control"
                  step=".1"
                  v-model="activeProperty.frontage"
                />
              </div>
              <div class="col-6 mb-4">
                Depth
                <input
                  type="number"
                  class="form-control"
                  step=".1"
                  v-model="activeProperty.depth"
                />
              </div>
              <div class="col-6 mb-4">
                Size
                <input
                  type="number"
                  class="form-control"
                  step=".1"
                  v-model="activeProperty.size"
                />
              </div>
              <div class="col-12 mb-4">
                View/Outlook Label
                <input
                  class="form-control"
                  type="text"
                  v-model="activeProperty.viewLabel"
                />
              </div>

              <div class="col-12 mb-4">
                View/Outlook Images
                <input-asset
                  v-model="activeProperty.viewImages"
                  :multiple="true"
                />
              </div>

              <div class="col-12 mb-4">
                Is visible on webfeed?<br>
                <toggle-button 
                  v-model="activeProperty.isVisibleOnWebfeed" 
                  :color="{ checked: '#28a745', unchecked: '#b8b8b8' }"
                  :sync="true"
                  :width="30" 
                  :height="20"
                />
              </div>
            </div>
          </div>

          <div class="col-6 mb-4">
            <div class="row">
              <div class="col-12 mb-4">
                Available Dwellings
                <input-single-select
                  v-model="activeProperty.dwellingId"
                  label="Dwellings"
                  :options="dwellingOptions"
                />
              </div>
            </div>
          </div>

          <div class="col-12">
            <button class="btn btn-sm btn-outline-danger" @click="closeModal">Cancel</button>
            <button class="btn btn-sm btn-primary ml-1" @click="saveProperty(activeProperty)">Save</button>
          </div>

        </div>
      </modal-popup>    
    </div>
</template>
<script>
import _ from 'lodash'
import InputAsset from '@/components/InputAsset'
import InputMultiSelect from '@/components/InputMultiSelect'
import InputSingleSelect from '@/components/InputSingleSelect'
import ModalPopup from '@/components/ModalPopup'
import CkEditor from '@/components/CKEditor'
import VTable from '@/components/VTable'

export default {
  components: { CkEditor, InputAsset, InputMultiSelect, InputSingleSelect, VTable },
  data () {
    return {
      activePropertyId: null,
      propertiesFilterText: '',
    }
  },

  computed: {
    activeProperty () {
      return _.find(this.properties, property => {
        return property._id === this.activePropertyId
      })
    },

    activeUser () {
      return this.$store.getters.user
    },

    filteredProperties () {
      return _.filter(this.properties, property => {
        return property.label.toLowerCase().includes(this.propertiesFilterText.toLowerCase())
      })
    },   

    properties () {
      return this.$store.getters.properties
    },

    dwellings () {
      return this.$store.getters.dwellings
    },

    dwellingOptions () {
      return this.dwellings.map(dwelling => {
        return {
          label: dwelling.label,
          value: dwelling._id
        }
      })
    },
  },

  methods: {
    async addProperty () {
      const { _id } = await this.$store.dispatch('ADD_NEW_PROPERTY')
      this.activePropertyId = _id
    },

    async cloneProperty (property) {
      const { _id } = await this.$store.dispatch('CLONE_PROPERTY', property)
      this.activePropertyId = _id
    },
    
    closeModal () {
      this.activePropertyId = null
      this.$store.dispatch('FETCH_PROPERTIES')
    },

    deleteProperty (id) {
      if (confirm('Are you sure?')) {
        this.$store.dispatch('DELETE_PROPERTY', id)
      }
    },

    saveProperty (property) {
      this.$store.dispatch('SAVE_PROPERTY', property)
      this.activePropertyId = null
    },
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
    this.$store.dispatch('FETCH_PROPERTIES')
    this.$store.dispatch('FETCH_DWELLINGS')
  }
}
</script>